<template>
	<el-footer style="height:300px;">
    <div class="bottom">
        <p class="lineOne">
          <el-row>
            <el-col :span="6">
              <img src="../../static/images/logo.png" alt="">
            </el-col>
            <el-col :span="18">
              <el-row class="right">
                <el-col :span="6">
                  <img src="../../static/images/icon_1.png" alt="">
                  <span class="name">7x24h服务</span>
                </el-col>
                <el-col :span="6">
                  <img src="../../static/images/icon_2.png" alt="">
                  <span class="name">培训&回访</span>
                </el-col>
                <el-col :span="6">
                  <img src="../../static/images/icon_3.png" alt="">
                  <span class="name">版本迭代</span>
                </el-col>
                <el-col :span="6">
                  <img src="../../static/images/icon_4.png" alt="">
                  <span class="name">系统安全巡检</span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </p>
        <p class="lineTwo">
          <el-row>
            <el-col :span="10">
              <p class="describe"><span class="company">浙江新华移动传媒股份有限公司</span> 是国内领先的新媒体科技公司，国家高新技术企业。公司以自主研发创新为主导，长期服务于各级宣传部门以及新华社、经济日报社、杭报集团等著名媒体机构。</p>
            </el-col>
            <el-col :span="14">
              <div class="tel">
                <el-row>
                  <el-col :span="8">
                    <img src="../../static/images/phone.png" alt="">
                  </el-col>
                  <el-col :span="16">
                    <p>0571-87838801</p>
                    <!-- <p>152 2564 3527</p> -->
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </p>
        <p class="lineThree">
          <el-row>
            <el-col :span="12">
              <p class="linkToHome"><a href="http://www.xinhuamm.net" target="_blank">了解更多详见公司官网 >>></a></p>
            </el-col>
            <el-col :span="12">
              <p class="licence">网络文化经营许可证：浙网文{2018}5199-425号；<a href="https://beian.miit.gov.cn" target="_blank">浙ICP备12035309号-14</a></p>
            </el-col>
          </el-row>
        </p>
      </div>
	</el-footer>
</template>
<script>
export default {
    name :"Parteight",
    data(){
        return{

        }
    }
}
</script>
<style scoped>
 .el-footer{
    color: #fff;
    padding: 0;
    background: #2d3033;
  }
  .el-footer .bottom{
    width: 1200px;
    margin: 0 auto;
		padding-top: 30px;
    /* border: 1px solid red; */
  }
  .el-footer .lineOne .right{
    text-align: right;
  }
  .el-footer .lineOne .right img{
    position: relative;
    top:5px;
  }
  .el-footer .lineTwo{
    border-top: 1px solid #43474B;
    margin-top: 20px;
    padding-top:24px;
  }
  .el-footer .lineTwo p.describe{
    font-size: 14px;
    color: #bbb;
    line-height: 26px;
  }
  .el-footer .lineTwo span.company{
    color:#4ED0BE;
    font-weight:600;
  }
  .el-footer .el-col-14{
    position: relative;
  }
  .el-footer .lineTwo .tel{
    position: absolute;
    right: 0;
    top:30px;
    width: 146px;
    height: 42px;
    border-radius: 4px;
    border: 1px solid #4ED0BE;
  }
  .el-footer .lineTwo .tel img{
    margin-top: 10px;
    margin-left: 12px;
  }
  .el-footer .lineTwo .tel p{
    color: #ddd;
    font-size: xx-small;
    margin: 0;
    line-height:40px;
  }
  .el-footer .lineThree{
    font-size: 12px;
		margin-top: 30px;
  }
  .el-footer .lineThree .linkToHome a{
    color: #4ED0BE;
    text-decoration: none;
  }
  .el-footer .lineThree .licence{
    text-align: right;
    color: #999;
  }
  .el-footer .lineThree .licence a{
    color: #999;
    text-decoration: none;
  }
	@media (max-width: 1439px){
		.el-footer .bottom{
      width: 1000px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/Parteight.vue